"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Compare = function Compare(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M93.942 60.011H52.207l15.425-15.124a2.337 2.337 0 0 0-3.239-3.34l-19.398 19.1a2.337 2.337 0 0 0 0 3.272L64.427 83.35a2.304 2.304 0 0 0 3.272 0 2.337 2.337 0 0 0 0-3.238L52.24 64.652h41.702a2.337 2.337 0 0 0 0-4.64M2.058 36.004h41.735L28.368 51.13a2.337 2.337 0 0 0 3.239 3.306l19.431-19.032a2.337 2.337 0 0 0 0-3.338L31.573 12.634a2.304 2.304 0 0 0-3.238 0 2.337 2.337 0 0 0 0 3.272l15.458 15.459H2.058a2.337 2.337 0 0 0 0 4.64",
    fill: "currentColor"
  })));
};
var _default = exports.default = Compare;